export default function CompanyProfile() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-black text-[#0A1628] mb-12 text-center font-serif">
          会社概要
        </h2>

        {/* Company Information */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12 border border-gray-200">
          <div className="space-y-6">
            <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-8">
              <div className="text-[#0A1628] font-bold min-w-[140px] font-serif">商号：</div>
              <div className="text-gray-700 font-serif">株式会社万燈</div>
            </div>
            
            <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-8">
              <div className="text-[#0A1628] font-bold min-w-[140px] font-serif">住所：</div>
              <div className="text-gray-700 font-serif">新宿区西新宿6-15-1ラトゥール新宿5F</div>
            </div>
            
            <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-8">
              <div className="text-[#0A1628] font-bold min-w-[140px] font-serif">代表取締役：</div>
              <div className="text-gray-700 font-serif">佐々木 雄哉</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}